<div class="modal-content">
    <div class="modal-header">
        <h6 id="company-register-participant-modal-title-text" class="modal-title">{{participant?'Edit Participants':'Add Participants'}}</h6>
        <button id="company-register-participant-modal-x-button" type="button" class="close" (click)=bsModalRef.hide()>
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form *ngIf="form" role="form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="modal-body">
            <div class="row">
                <div class="col-md-6">
                    <div>
                        <label id="company-register-participant-modal-field-name-text"
                            for="company-register-participant-modal-field-name-input" class="col-form-label">
                            Name <span class="text-danger">(No Title Required)*</span>
                        </label>
                        <input id="company-register-participant-modal-field-name-input" 
                            type="text" 
                            class="form-control"
                            name="firstName" 
                            (blur)="onCheckAndRemoveWording('firstName')"
                            (keypress)="onKeyPressCharacters($event)" 
                            formControlName="firstName" 
                            autocomplete="new-firstName" required>
                        <small id="company-register-participant-modal-field-name-required-error-text" class="invalid-input"
                            *ngIf="(submitted || f.firstName.dirty) && f.firstName.invalid">
                            Name is required
                        </small>
                    </div>
                </div>
                <div class="col-md-6">
                    <div>
                        <label id="company-register-participant-modal-field-surname-text" for="company-register-participant-modal-field-surname-input" class="col-form-label">
                            Surname <span class="text-danger">*</span>
                        </label>
                        <input id="company-register-participant-modal-field-surname-input" 
                            type="text" 
                            class="form-control"
                            formControlName="lastName" 
                            (keypress)="onKeyPressCharacters($event)"
                            (blur)="onCheckAndRemoveWording('lastName')" 
                            autocomplete="new-lastName" required>
                        <small id="company-register-participant-modal-field-surname-required-error-text" class="invalid-input"
                            *ngIf="(submitted || f.lastName.dirty) && f.lastName.invalid">
                            Surname is required
                        </small>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div>
                        <label id="company-register-participant-modal-field-email-text" for="company-register-participant-modal-field-email-input" class="col-form-label">
                            Email <span class="text-danger">*</span>
                        </label>
                        <input id="company-register-participant-modal-field-email-input" 
                            type="email" 
                            class="form-control"
                            formControlName="email" 
                            placeholder="example@xxx.or.th" 
                            (keypress)="onKeyPressExcludeTH($event)" 
                            [email]="true" required>
                        <small *ngIf="f.email.errors?.incorrect"
                            id="company-register-participant-modal-field-email-already-used-error-text"
                            class="text-danger">
                            Email is already registered.
                        </small>
                        <div class="invalid-input" *ngIf="(submitted || f.email.dirty) && f.email.invalid">
                            <p *ngIf="f.email.errors?.required"
                                id="company-register-participant-modal-field-email-required-error-text">
                                <small>Email is required</small>
                            </p>
                            <p *ngIf="f.email.errors?.pattern"
                                id="company-register-participant-modal-field-email-pattern-error-text">
                                <small>Please provide a valid email address</small>
                            </p>
                            <p *ngIf="f.email.errors?.duplicateInCompany"
                                id="company-register-participant-modal-field-email-duplicated-error-text">
                                <small>Duplicate email to other participants</small>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div>
                        <label id="company-register-participant-modal-field-mobile-text" for="company-register-participant-modal-field-mobile-input" class="col-form-label">
                            Mobile <span class="text-danger">*</span>
                        </label>
                        <div>
                            <ngx-intl-tel-input #mobileNumber [preferredCountries]="[countryISO.Thailand]"
                                [searchCountryFlag]="true"
                                [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]"
                                [selectedCountryISO]="countryISO.Thailand"
                                [phoneValidation]="true" [enablePlaceholder]="true" name="mobileNumber"
                                [inputId]="'company-register-participant-modal-field-mobile-input'"
                                formControlName="mobileNumber">
                            </ngx-intl-tel-input>
                        </div>
                        <p id="company-register-participant-modal-field-mobile-required-error-text" class="invalid-input"
                            *ngIf="submitted && f.mobileNumber.invalid">
                            <small *ngIf="f.mobileNumber.errors?.required">
                                Mobile is required.
                            </small>
                            <small id="company-register-participant-modal-mobile-pattern-error-text"
                                *ngIf="f.mobileNumber.errors?.validatePhoneNumber">
                                Mobile is invalid pattern.
                            </small>
                        </p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div>
                        <label id="company-register-participant-modal-field-ext-number-text"
                            for="company-register-participant-modal-field-ext-number-input" class="col-form-label">
                            Ext. Number
                        </label>
                        <div>
                            <input id="company-register-participant-modal-field-ext-number-input" type="text"
                                class="form-control" formControlName="extNumber">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5">
                    <div class="form-group form-check">
                        <input id="company-register-participant-modal-field-receive-email-input" 
                            type="checkbox"
                            class="form-check-input form-checkbox" 
                            value=true 
                            formControlName="willReceiveEmail">
                        <label id="company-register-participant-modal-field-receive-email-text" class="form-check-label"
                            for="company-register-participant-modal-field-receive-email-input">
                            To receive notify email
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div>
                        <label id="company-register-participant-modal-field-job-text" or="company-register-participant-modal-field-job-input" class="col-form-label">
                            Job Title <span class="text-danger">*</span>
                        </label>
                        <input id="company-register-participant-modal-field-job-input" 
                            type="text" 
                            class="form-control"
                            formControlName="jobTitle" 
                            (keypress)="onKeyPressCharacters($event)" required>
                        <small id="company-register-participant-modal-field-job-required-error-text" class="invalid-input"
                            *ngIf="(submitted || f.jobTitle.dirty) && f.jobTitle.invalid">
                            Job Title is required
                        </small>
                    </div>
                </div>
                <div class="col-md-6">
                    <div>
                        <label id="company-register-participant-modal-field-department-text"
                            for="company-register-participant-modal-field-department-input"
                            class="col-form-label">
                            Department
                        </label>
                        <input id="company-register-participant-modal-field-department-input" 
                            type="text" 
                            class="form-control"
                            formControlName="department" 
                            (keypress)="onKeyPressCharacters($event)" >
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <label class="mt-3 col-form-label font-weight-bold">
                        Role <span class="text-danger">*</span>
                        <small *ngIf="form.errors?.roleRequired && (f.isParticipant.dirty || f.isAttendee.dirty || f.isContact.dirty)" class="text-danger">
                                Please select exactly one role
                        </small>
                    </label>

                    <div class="form-group form-check" style="margin-bottom: 0.5rem;">
                        <input id="company-register-participant-modal-field-speaker-input" 
                            type="checkbox"
                            class="form-check-input form-checkbox" 
                            value=true 
                            formControlName="isParticipant">
                        <label id="company-register-participant-modal-field-speaker-text" class="form-check-label"
                            for="company-register-participant-modal-field-speaker-input">Speaker</label>
                    </div>
                    <div class="form-group form-check" style="margin-bottom: 0.5rem;">
                        <input id="company-register-participant-modal-field-attendee-input" 
                            type="checkbox"
                            class="form-check-input form-checkbox" 
                            value=true 
                            formControlName="isAttendee">
                        <label id="company-register-participant-modal-field-attendee-text" class="form-check-label"
                            for="company-register-participant-modal-field-attendee-input">Attendee</label>
                    </div>
                    <div class="form-group form-check">
                        <input 
                            id="company-register-participant-modal-field-contact-input" 
                            type="checkbox"
                            class="form-check-input form-checkbox" 
                            value=false 
                            formControlName="isContact">
                        <label id="company-register-participant-modal-field-contact-text" class="form-check-label"
                            for="company-register-participant-modal-field-contact-input">Contact Person</label>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="isShowDietary && f.isParticipant.value">
                <div class="col-md-6">
                    <div>
                        <label id="company-register-participant-modal-field-dietary-text"
                            for="company-register-participant-modal-field-dietary-selector" class="col-form-label">
                            Dietary requirements
                        </label>
                        <select class="form-control" id="company-register-participant-modal-field-dietary-selector"
                            formControlName="dietaryRequirementId">
                            <option [ngValue]="null">Other dietary</option>
                            <option *ngFor="let dietary of dietaries" [ngValue]="dietary.dietaryId">
                                {{dietary.dietaryName}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="form.value.dietaryRequirementId == null">
                    <div>
                        <label id="company-register-participant-modal-field-other-dietary-text"
                            for="company-register-participant-modal-field-other-dietary-input" class="col-form-label">
                            Other dietary
                        </label>
                        <input type="text" id="company-register-participant-modal-field-other-dietary-input"
                            class="form-control" name="otherDietary" formControlName="otherDietary">
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button id="participant-modal-close-button" type="button" class="btn btn-secondary" (click)=bsModalRef.hide()>Close</button>
            <button id="participant-modal-save-button" type="submit" class="btn btn-primary" [disabled]="form.invalid">Save</button>
        </div>
    </form>

</div>